export const groupResultByAbstractUuid = (arrayOfVariable) => {
    const mappedResult = [];

    arrayOfVariable.forEach((item) => {
        const existingAbstractUuid = mappedResult.find((abstract) => abstract.abstractUUID === item.uuid);

        const { uuid, gatewayName } = item;
        delete item.uuid;
        delete item.gatewayName;
        if (existingAbstractUuid) {
            existingAbstractUuid.mappings.push(item);
        } else {
            mappedResult.push({
                abstractUUID: uuid,
                gatewayName,
                mappings: [item],
            });
        }
    });

    return mappedResult;
};
